<!--
 * @Description: 水泥胶砂
 * @Author: wangwangwang
 * @Date: 2020-09-21 14:09:06
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-12-28 17:33:06
-->
<template>
  <div class="pages_content table">
    <el-container>
      <el-header>
        <breaDcrumb />
      </el-header>
      <el-main style="width: 100%">
        <div>
          <div class="header_right" @click="showCardNav = !showCardNav">
            <div class="title">搜索</div>
            <div>
              <transition name="from"></transition>
              <span v-show="!showCardNav">
                <i style="margin-right: 5px" class="el-icon-arrow-down"></i>
              </span>
              <transition name="to"></transition>
              <span v-show="showCardNav">
                <i style="margin-right: 5px" class="el-icon-arrow-up"></i>
              </span>
            </div>
          </div>
          <div v-show="showCardNav" class="hr"></div>
          <el-collapse-transition>
            <div v-show="showCardNav">
              <div class="search">
                <el-form ref="form" inline :model="tableParam" label-width="80px">
                  <el-form-item label="创建时间">
                    <el-date-picker v-model="tableParam.time" type="daterange" value-format="yyyy-MM-dd HH:mm:ss" range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间" @change="e => this.changeTime(e)">
                    </el-date-picker>
                  </el-form-item>
                  <el-form-item label="站点">
                    <el-input v-model="tableParam.stationName" placeholder="请输入" />
                  </el-form-item>
                  <el-form-item label="编号">
                    <el-input v-model="tableParam.code" placeholder="请输入" />
                  </el-form-item>
                  <el-form-item>
                    <el-button icon="el-icon-search" size="medium" class="bottom_all" @click="searchSubmit()">查 询</el-button>
                    <el-button size="medium" class="bottom_all_two" style="margin-left: 12px" @click="init()">重 置</el-button>
                  </el-form-item>
                </el-form>
              </div>
            </div>
          </el-collapse-transition>
          <el-button size="medium" class="bottom_all" @click="add()">添 加</el-button>
          <div style="height: 10px"></div>
          <div class="hr"></div>
          <div class="card">
            <div v-loading="tableLoading" class="card_info" style="width: 100%">
              <el-table :header-cell-style="{ background: '#f3f6f9' }" height="500" :cell-style="{ borderRight: 'none' }" border stripe :data="tableData" tooltip-effect="dark">
                <el-table-column prop="stationName" label="站点"></el-table-column>
                <el-table-column prop="code" label="编号"></el-table-column>
                <el-table-column prop="sevenDayAvg" label="7d抗压强度">
                  <template slot-scope="scoped">{{ (scoped.row.sevenDayAvg * 1).toFixed(1) }}</template>
                </el-table-column>
                <el-table-column prop="twentyEightDayAvg" label="28d抗压强度">
                  <template slot-scope="scoped">{{ (scoped.row.twentyEightDayAvg * 1).toFixed(1) }}</template>
                </el-table-column>
                <el-table-column prop="referenceMobility" label="基准流动度"></el-table-column>
                <el-table-column prop="createUserName" label="操作人"></el-table-column>
                <el-table-column prop="createTime" label="创建时间"></el-table-column>
                <el-table-column prop="carNo" label="操作">
                  <template slot-scope="{ row }">
                    <span style="color: #018a46; cursor: pointer" @click="examine(row)">查 看</span>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </el-main>
      <div class="card_bottom">
        <div class="card_bottom_left">
          <div class="top_page_totle">总共{{ total }}条</div>
          <el-pagination
            :current-page.sync="tableParam.page"
            :page-size="tableParam.pageSize"
            :page-sizes="[10, 20, 30, 40, 50, 100, 200, 500, 1000]"
            layout="prev,pager,sizes,next,jumper"
            :total="total"
            @size-change="sizeChange"
            @current-change="searchSubmit()"
          ></el-pagination>
        </div>
        <div>
          <el-button size="mini" icon="el-icon-refresh-right" class="bottom_all_two" @click="searchSubmit()">刷新</el-button>
        </div>
      </div>
    </el-container>

    <CementMortarDialog :visible.sync="cementMortarVisible" :config="cementMortarConfig" @updated="init" />
  </div>
</template>

<script>
import CementMortarDialog from "./components/CementMortarDialog";
import mixin from "@/mixins/ICPSmixin.js";
import { queryPage } from "@/api/cementMortar";
export default {
  mixins: [mixin],
  components: {
    CementMortarDialog,
  },
  data() {
    return {
      showCardNav: true,
      tableParam: {
        stationName: "", // 站点名
        code: "", // 编码
        createTime: "", // 开始时间
        updateTime: "", // 结束时间
        page: 1,
        pageSize: 10,
      },
      total: 0,
      tableData: [],
      tableLoading: false,

      cementMortarVisible: false,
      cementMortarConfig: {},
    };
  },
  created() {
    this.init();
  },
  methods: {
    // 选择时间时间
    changeTime(e) {
      if (e) {
        this.tableParam.createTime = e[0];
        this.tableParam.updateTime = e[0];
      } else {
        this.tableParam.createTime = "";
        this.tableParam.updateTime = "";
      }
    },
    // 查看
    examine(row) {
      this.cementMortarConfig = {
        type: "examine",
        data: { ...row },
      };
      this.cementMortarVisible = true;
    },
    // 添加
    add() {
      this.cementMortarConfig = {
        type: "add",
        data: {},
      };
      this.cementMortarVisible = true;
    },
    // 查询
    searchSubmit() {
      queryPage(this.tableParam).then(res => {
        if (res && res.code === 1001) {
          this.tableData = res.data.data;
          this.total = res.data.totalRows;
        }
      });
    },
    // 重置
    init() {
      this.tableParam = this.$options.data().tableParam;
      this.searchSubmit();
    },
    // 改变页数
    sizeChange(e) {
      this.tableParam.page = e;
      this.searchSubmit();
    },
    // 改变页码
    currentChange(e) {
      this.tableParam.pageSize = e;
      this.searchSubmit();
    },
  },
};
</script>
<style lang="scss" scoped>
.pages_content {
  width: 100%;
}
</style>
